import React from 'react'
import { WebPlayerView } from 'unified-video-framework/web'

const NexusPlayer = ({ themeMode, title, player_image, url, fallbackUrl1, fallbackUrl2, fallbackUrl3, controls, freeDuration, mute, newsTickerContents, enableNewsTicker }) => {

    const newsTickerConf = newsTickerContents ? newsTickerContents?.map((item, index) => ({
        id: `news-${index + 1}`,
        introText: item.intro_text,
        headline: item.heading_text,
        text: item.news_text,
        showIntro: true,
        introAnimation: 'scale',
    })) : null

    return (
        <WebPlayerView
            url={url}
            fallbackSources={[{ url: fallbackUrl1 }, { url: fallbackUrl2 }, { url: fallbackUrl3 }]}
            fallbackPoster={player_image}
            fallbackShowErrorMessage={true}
            freeDuration={freeDuration}
            isLive={true}
            liveWaitingMessages={{
                waitingForStream: "Stream starting soon",
            }}
            navigation={{
                backButton: {
                    enabled: false,
                    icon: 'arrow',
                    title: `Back to ${title} details page`,
                    ariaLabel: 'Go back to the gallery',
                    onClick: () => window.history.back(),
                    exitFullscreen: true,
                },
                closeButton: {
                    enabled: false,
                    icon: 'x',
                    title: `Back to ${title} details page`,
                    ariaLabel: 'Close the video player',
                    exitFullscreen: true,
                    onClick: () => window.history.back()
                }
            }}
            youtubeNativeControls={false}
            responsive={{ enabled: true, aspectRatio: 16 / 9, maxWidth: '100vw', maxHeight: '100vh' }}
            style={{ width: '100%', height: '100%', maxWidth: '100vw', maxHeight: '100vh', borderRadius: 0 }}
            playerTheme={{
                accent: `${themeMode?.button}`, accent2: `${themeMode?.button}`,
                iconColor: '#ffffff', textPrimary: '#ffffff',
                textSecondary: '#cccccc', overlayStrong: 'rgba(0,0,0,0.95)',
            }}
            controls={controls}
            metadata={{
                title: `${title}`
            }}
            controlsVisibility={{
                playback: { centerPlayButton: true, playPauseButton: false, skipButtons: false },
                audio: { volumeButton: false },
                progress: { progressBar: false, timeDisplay: false },
                quality: { badge: false, settingsButton: false },
                display: { fullscreenButton: true, pipButton: false },
                features: { shareButton: false, castButton: false, epgButton: false, playlistButton: false },
                chrome: { frameworkBranding: false }
            }}
            // flashNewsTicker={{
            //     enabled: enableNewsTicker,
            //     position: 'bottom',
            //     gap: 250,
            //     styleVariant: 'broadcast',
            //     speed: 5,

            //     broadcastStyle: {
            //         layoutStyle: 'professional',
            //         theme: 'breaking-blue',
            //         headerText: 'Flash NEWS',
            //         showGlobe: true,
            //         showLiveBadge: true,
            //         animateGlobe: true,
            //         pulseLiveBadge: true,
            //         headerHeight: 28,
            //         headerFontSize: 16,
            //         headerColor: 'linear-gradient(90deg, #4a0080, #800080)',
            //         bodyColor: 'linear-gradient(90deg, #1a1a3e, #2a2a5e)',

            //         // Two-line display configuration
            //         twoLineDisplay: {
            //             enabled: true,
            //             topLine: {
            //                 mode: 'static',
            //                 multiLine: true,
            //                 maxLines: 2,
            //                 minHeight: 36,
            //                 fontSize: 16,
            //                 lineHeight: 1.3,
            //                 padding: 8,
            //             },
            //             bottomLine: {
            //                 speed: 7,
            //                 height: 28,
            //                 fontSize: 14,
            //                 gap: 250,
            //             },
            //             showSeparator: true,
            //             separatorColor: 'rgba(255,255,255,0.2)',
            //         },

            //         // Decorative separator between globe and text
            //         decorativeShapes: {
            //             headerSeparator: {
            //                 type: 'pulse-line',
            //                 animated: true,
            //                 color: '#ffffff',
            //                 width: 2,
            //                 height: 18,
            //             },
            //         },

            //         defaultIntroAnimation: 'slide-in',
            //         defaultIntroDuration: 2000,
            //     },

            //     // Item cycling configuration
            //     itemCycling: {
            //         enabled: true,
            //         defaultDuration: 20,
            //         transitionType: 'fade',
            //         transitionDuration: 500,
            //         showProgress: true,
            //         progressColor: '#ffffff',
            //         progressHeight: 3,
            //         pauseOnHover: true,
            //     },

            //     // News items with Tamil and English content
            //     items: [...newsTickerConf
            //         // {
            //         //     id: 'news-1',
            //         //     headline: 'தங்கம் விலை கிராமுக்கு ரூ.515 உயர்வு - சென்னையில் புதிய சாதனை',
            //         //     text: 'இன்று காலை தங்கம் விலை திடீரென உயர்ந்தது. 22 காரட் தங்கம் கிராமுக்கு ரூ.6,250 ஆக விற்பனையாகிறது. முதலீட்டாளர்கள் கவனத்துடன் செயல்',
            //         //     // duration: 12,
            //         //     introText: 'BREAKING',
            //         //     showIntro: true,
            //         //     introAnimation: 'scale',
            //         // },

            //     ]
            // }}
            flashNewsTicker={{
                enabled: enableNewsTicker,
                position: 'bottom',
                styleVariant: 'broadcast',

                broadcastStyle: {
                    layoutStyle: 'professional',
                    theme: 'breaking-red',
                    headerText: 'BREAKING NEWS',
                    showGlobe: true,
                    showLiveBadge: true,
                    animateGlobe: true,
                    pulseLiveBadge: true,
                    headerHeight: 28,
                    headerFontSize: 16,

                    // Two-line display configuration
                    twoLineDisplay: {
                        enabled: true,
                        topLine: {
                            mode: 'static',
                            multiLine: true,
                            maxLines: 2,
                            minHeight: 36,
                            fontSize: 16,
                            lineHeight: 1.3,
                            padding: 8,
                        },
                        bottomLine: {
                            speed: 8,
                            height: 28,
                            fontSize: 14,
                        },
                        showSeparator: true,
                        separatorColor: 'rgba(255,255,255,0.2)',
                    },

                    // Decorative separator between globe and text
                    decorativeShapes: {
                        headerSeparator: {
                            type: 'pulse-line',
                            animated: true,
                            color: '#ffffff',
                            width: 2,
                            height: 18,
                        },
                    },

                    defaultIntroAnimation: 'slide-in',
                    defaultIntroDuration: 2000,
                },

                // Item cycling configuration
                itemCycling: {
                    enabled: true,
                    defaultDuration: 10,
                    transitionType: 'fade',
                    transitionDuration: 500,
                    showProgress: true,
                    progressColor: '#ffffff',
                    progressHeight: 3,
                    pauseOnHover: true,
                },

                // News items with Tamil and English content
                items: [...newsTickerConf]
            }}
            autoPlay={true}
            muted={mute}
            enableAdaptiveBitrate={true}
            debug={false}
            title={title}
            poster={player_image}
            watermark={false}
            settings={{ playbackRates: false, subtitles: false, speed: false }}
            showFrameworkBranding={false}
            onReady={(player) => { window.player = player }}
            onError={(error) => { console.error('❌ Player error:', error) }}
            onVideoStart={() => { console.log('▶️ Video playback started') }}
            onVideoEnd={() => { console.log('⏹️ Video playback ended') }}
            onPlay={() => { console.log('▶️ Video play event') }}
            onPause={() => { console.log('⏸️ Video pause event') }}
        />
    )
}

export default NexusPlayer